module.exports = __webpack_public_path__ + "img/ngo_skype_contact.ee984c69.png";